import { render, staticRenderFns } from "./PermissionsEdit.vue?vue&type=template&id=049bc632&"
import script from "./PermissionsEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports